import { axiosService } from '../.';

export default class UpdateOrganizationBusinessExternalLinks {
    public async execute(input: UpdateOrganizationBusinessExternalLinksDto): Promise<void> {
        await axiosService.instance.post(`businesses/organization/update-external-links`, input);
    }
}

export class UpdateOrganizationBusinessExternalLinksDto {
    private businessId: number;
    private links: UpdateOrganizationBusinessExternalLinksLinkDto[];

    constructor(businessId: number, links: UpdateOrganizationBusinessExternalLinksLinkDto[]) {
        this.businessId = businessId;
        this.links = links;
    }
}

export class UpdateOrganizationBusinessExternalLinksLinkDto {
    private title: string;
    private url: string;
    private type: number;

    constructor(title: string, url: string, type: number) {
        this.title = title;
        this.url = url;
        this.type = type;
    }
}

export const updateOrganizationBusinessExternalLinks = new UpdateOrganizationBusinessExternalLinks();
